import axiosInstance from '../config/axios';

// Lessons CRUD
export const createLesson = (data) =>
  axiosInstance.post('/lessons', data).then((res) => res.data);

export const upsertLessonFull = (data) =>
  axiosInstance.post('/lessons/full', data, {
    headers: {
      'Content-Type': undefined,
    }
  }).then((res) => res.data);

export const getLessons = (id) =>
  axiosInstance.get(`/lessons/${id}`).then((res) => res.data);

export const getLessonById = (id) =>
  axiosInstance.get(`/lessonsById/${id}`).then((res) => res.data);

export const deleteLesson = (id) =>
  axiosInstance.delete(`/lessons/${id}`).then((res) => res.data);

export const addMcqToLesson = (id, data) =>
  axiosInstance.post(`/lessons/${id}/mcqs`, data).then((res) => res.data);

export const submitAnswers = (data) =>
  axiosInstance.post('/answers', data).then((res) => res.data);
